<template>
  <m-contents-wrapper :slicer="slicer"
                      :content-type="contentType"
                      :pause-if-category-not-found="pauseIfCategoryNotFound"
                      :content-category="contentCategory"
  >
    <div slot-scope="{contents,pagination,changePageFunction}">
      <b-row>
        <b-col class="mb-5" lg="3" v-if="categoryPanel">
          <m-categories-panel-300 link-type="blog" :flat-categories-shape="flatCategoriesShape"
                                  class="sticky-top categories-panel-300-z-index rounded rounded-4 mx-auto"/>
        </b-col>
        <b-col :lg="postsSectionSize">
          <b-row align-h="center">
            <b-col class="my-5" lg="4" v-for="content in contents" :key="content.id">
              <m-c303 :image="content.thumbnail" :alt="content.title">

                <m-a class="text-dark" :href="{name:'SinglePost',params:{slug:content.slug}}">
                  <h5>{{ content.title }}</h5>
                </m-a>

                <m-a :href="{name:'SinglePost',params:{slug:content.slug}}">
                  <b-button class="border-0 text-muted font-weight-bold" variant="transparent" size="sm">
                    <span class="pl-1">بیشتر بخوانید</span>
                    <b-icon icon="arrow-left"/>
                  </b-button>
                </m-a>


              </m-c303>
            </b-col>
          </b-row>
          <b-row v-if="paginate">
            <b-col lg="12">
              <m-pagination-400 :meta="pagination" :on-change-page="changePageFunction"/>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
  </m-contents-wrapper>
</template>

<script>
import {DefaultProps} from "./DefaultProps";

export default {
  name: "Posts300",
  props: DefaultProps,
  computed: {
    postsSectionSize() {
      if (this.categoryPanel) {
        return 9;
      }
      return 12;
    }
  }
}
</script>

<style scoped>
.categories-panel-300-z-index {
  z-index: 0 !important;
}
</style>